import {Component, computed, input} from '@angular/core';
import {IackathonSave} from '../../../../services/iackathon-saves.service';

@Component({
  selector: 'app-iackathon-step-problematic',
  imports: [],
  templateUrl: './iackathon-step-problematic.component.html',
  styleUrl: './iackathon-step-problematic.component.scss',
})
export class IackathonStepProblematicComponent {
    save = input.required<IackathonSave>();
    private state = computed(() => this.save().attributes.content.state);
    protected readonly problematicTheme = computed(() => this.state().sdg_theme_step?.chosen_theme);
    protected readonly problematic = computed(() => this.state().problem_step?.problematic);

}
